import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import styles from './../../../../Styles';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import ViewListIcon from '@material-ui/icons/ViewList';
import aggregate_sl_init from './../images/aggregate_sl_init.png';
import aggregate_sl_active from './../images/aggregate_sl_active.png';
import aggregate_sl_results from './../images/aggregate_sl_results.png';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const INITIAL_STATE = {
    open: false,
    legendOpen: false
};

class HostInstructions extends Component {

    constructor(props) {
        super(props);
        this.state = {
          ...INITIAL_STATE,
        };
    }

    handleClickOpen = () => {
        this.setState({
            ...this.state,
            open: true
        });
    };
    
    handleClose = () => {
        this.setState({
            ...this.state,
            open: false
        });
    };

    handleLegendClickOpen = () => {
        this.setState({
            ...this.state,
            legendOpen: true
        });
    };
    
    handleLegendClose = () => {
        this.setState({
            ...this.state,
            legendOpen: false
        });
    };

    render() {
        const {
        classes,
        } = this.props;

        return (
        <div>
            <Typography variant='h5' className={classes.greyText}>
                Host Tools
            </Typography>
            <div className={classes.spacingTop}>
                <div><Button 
                        variant="contained"
                        color="primary"
                        startIcon={<SpeakerNotesIcon />}
                        onClick={this.handleClickOpen}
                        >
                    Leader Notes
                    </Button>
                    <div className={classes.spacingTop}>
                        <Button 
                            variant="contained"
                            color="primary"
                            startIcon={<ViewListIcon />}
                            onClick={this.handleLegendClickOpen}
                            >
                        State Legend
                        </Button>
                    </div>
                </div>
            </div>
            <Dialog open={this.state.open} onClose={this.handleClose} TransitionComponent={Transition}>
                <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                    <CloseIcon />
                    </IconButton>
                        <Typography variant="h6" className={classes.boldedText}>
                        Leader Notes
                        </Typography>                    
                </Toolbar>
                </AppBar>
                <Grid container spacing={2} className={classes.dialogueGrid}>
                    <Grid item xs={12}  className={classes.spacingTop}>
                        <div className={classes.bodyText}>
                            <div className={classes.boldedText}>Story</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>An architect has come up with plans for a new condo complex, however, before he could complete the drawings, he quit the job</li>
                                <li className={classes.properListItem}>Your team will complete the Architects drawings for the ground floor of a condo complex.</li>
                                <li className={classes.properListItem}>You will only have the Architect’s notes to complete the construction.</li>
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>Clues to Focus on</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>Two types of walls – adjacent and outside – what does this mean?</li>
                                <li className={classes.properListItem}>The Shopping Complex consists of 12 equally sized cubes. Each store in the Shopping Complex consists of 3 cubes– you have 28 cubes; what should you do?</li>
                                <li className={classes.properListItem}>“Each store in the Shopping Complex is identical in shape”. – What are the choices for laying out the 3 blocks per section? What shape must it be?</li>
                                <li className={classes.properListItem}>You can access the fitness center from anywhere on the ground floor of the condo complex – where must the fitness center be?</li>
                                <li className={classes.properListItem}>The bottom left area of the complex is a mirror reflection of bottom right side – if blocks can only be laid out in a few formations, what does this mean for the shape of the bottom left and bottom right areas?</li>
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>Puzzle Card</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>What did we do well as a team?</li>
                                <li className={classes.properListItem}>What could we have done differently?</li>                               
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>Debrief</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>What Assumptions did the team make?</li>
                                <li className={classes.properListItem}>How did this impact your progress?</li>                               
                            </ul>
                        </div>                     
                    </Grid>
                </Grid>              
            </Dialog>
            <Dialog  open={this.state.legendOpen} onClose={this.handleLegendClose} TransitionComponent={Transition}>
                <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={this.handleLegendClose} aria-label="close">
                    <CloseIcon />
                    </IconButton>
                        <Typography variant="h6" className={classes.boldedText}>
                        State Legend
                        </Typography>                    
                </Toolbar>
                </AppBar>
                <Grid container spacing={2} className={classes.dialogueGrid}>
                    <Grid item xs={12}  className={classes.spacingTop}>
                        <Typography variant="body1" className={`${classes.boldedText} ${classes.spacingTop}`}>Init</Typography>
                        <div>
                            <img src={aggregate_sl_init} alt='aggregate intro' className={`${classes.imageSize} ${classes.borderImage}`}/>
                        </div>
                        <Typography variant="body1" className={`${classes.boldedText} ${classes.spacingTop}`}>Active</Typography>
                        <div>
                            <img src={aggregate_sl_active} alt='activity example' className={`${classes.imageSize} ${classes.borderImage}`}/>
                        </div>
                        <Typography variant="body1" className={`${classes.boldedText} ${classes.spacingTop}`}>Results</Typography>
                        <div>
                            <img src={aggregate_sl_results} alt='activity complete now waiting for others' className={`${classes.imageSize} ${classes.borderImage}`}/>
                        </div>
                    </Grid>
                </Grid>             
            </Dialog>
        </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(HostInstructions);